import { IconCross, IconCalendarRound } from '../ui'
import uniqid from 'uniqid'
import { Form } from 'react-bootstrap'
import { IFilterDate } from '../../types'
import DatePicker from 'react-datepicker'
import dt from 'dayjs'

export const FilterDate = (props: IFilterDate) => {
	const {
		attr,
		value,
		setValue,
		label,
		placeholder,
		styles = {},
		isClearable = false,
		isDisabled = false,
		filterDate = (date: Date | dt.Dayjs | string) => true,
		highlightDates = [],
		locale = '',
		showMonthYearPicker = false,
		isIconRightVisible = false,
		iconRight = <IconCalendarRound size={20}/>
	} = props
	const key = uniqid()

	return (
		<div className="filter-input-cont" style={styles}>
			{label ? <Form.Label className="text-dark" htmlFor={`date-${key}`}>{label}</Form.Label> : null}

			<div className={'src-form position-relative'}>
				<DatePicker
					id={`date-${key}`}
					className="form-control"
					// selectsDisabledDaysInRange
					// showMonthDropdown
					// showYearDropdown
					{...attr}
					placeholderText={placeholder}
					disabled={isDisabled}
					selected={value && dt(value).isValid() ? dt.utc(value).toDate() : null}
					onChange={(value: Date | null) => setValue(value ? dt.utc(value).format('YYYY-MM-DD') : '')}
					dateFormat="dd/MM/yyyy"
					// showWeekNumbers
					filterDate={filterDate}
					highlightDates={highlightDates}
					locale={locale}
					showMonthYearPicker={showMonthYearPicker}
				/>
				<div className={'input-buttons bg-transparent position-absolute top-50 translate-middle-y'}>
					{!isDisabled && isClearable && !!value ? (
						<i className="icon-cross" onClick={(event) => setValue('')}>
							<IconCross/>
						</i>
					) : null}

					{isIconRightVisible ? (
						<>
							<span className="indicator-separator"></span>

							<i className="icon-calendar-round">
								{iconRight}
							</i>
						</>
					) : null}
				</div>
			</div>
		</div>
	)
}